module.exports = __webpack_public_path__ + "static/img/customer10.777983e9.png";